angular.module('unica_user.user_controllers')

.controller('UserCreateController', function(
	$rootScope, $scope, $state,
	UserCreateService
) {

	$scope.passwordRequired = true;

	$rootScope.userData = {};

	// $rootScope.userData = {
	// 	"fiscal_code": "RGGFPP89C16G283Q",
	// 	"password": "12345678",
	// 	"category": "agent",
	// 	"role": "agent",
	// 	"sub_role": "agent",
	// 	"email": "testagente@email.com",
	// 	"mobile": "12345678",
	// 	"first_name": "test",
	// 	"last_name": "test",
	// 	"privacy": true,
	// 	"dob": "2018-12-03"
	// };


	$scope.saveUser = function() {
		$scope.showLoader();
		UserCreateService
			.create($rootScope.userData)
			.then(function(user) {
				$scope.hideLoader();

				if ( user ) {
					$scope.showSuccessMsg('Utente aggiunto con successo!', '');

					if ( user.role === 'admin' || user.role === 'service' || user.role === 'report_manager' || user.role === 'cons_welfare' ) {
						$state.go('app.user.list');
					} else {
						$state.go('app.user.edit_second_step', { id : user.id });
					}
				}
			});
	};

});